import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HasPermissionDirective } from '../../utils/has-permission.directive';
import { ReportVariablesComponent } from './report-variables/report-variables.component';
import { JudicialDepositsComponent } from './judicial-deposits/judicial-deposits.component';
import { LocalitiesComponent } from './localities/localities.component';

type OrganizationConfigTab = 'report-variables' | 'judicial-deposits' | 'localities';

@Component({
  selector: 'app-organization-config',
  standalone: true,
  imports: [
    CommonModule,
    HasPermissionDirective,
    ReportVariablesComponent,
    JudicialDepositsComponent,
    LocalitiesComponent,
  ],
  templateUrl: './organization-config.component.html',
  styleUrl: './organization-config.component.scss',
})
export class OrganizationConfigComponent implements OnInit {
  activeTab: OrganizationConfigTab = 'report-variables';

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    const tab = this.activatedRoute.snapshot.queryParamMap.get('tab');
    if (tab === 'judicial-deposits' || tab === 'report-variables' || tab === 'localities') {
      this.activeTab = tab;
    }
  }

  setTab(tab: OrganizationConfigTab): void {
    this.activeTab = tab;
  }
}
